<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav class="nav-bar">
      <div class="nav-container">
        <router-link to="/" class="nav-item">首页</router-link>
        <router-link to="/item-data" class="nav-item">商品数据</router-link>
        <router-link to="/official" class="nav-item">授公众号</router-link>
        <router-link to="/video" class="nav-item">搜视频号</router-link>
        <router-link to="/products" class="nav-item">搜产品</router-link>
        <router-link to="/timeline" class="nav-item">时间轴</router-link>
        <router-link to="/categories" class="nav-item">淘类目榜单</router-link>
      </div>
    </nav>

    <!-- 路由视图 -->
    <div class="router-view-container">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="footer-content">
        <span class="footer-item">数据来源：
          <span class="footer-links">
            <a href="#" class="small-link">微信</a>
            <a href="#" class="small-link">1688</a>
            <a href="#" class="small-link">淘宝</a>
            <a href="#" class="small-link">每日融资</a>
          </span>
        </span>
        <span class="footer-divider">|</span>
        <span class="footer-item">网站导航：
          <span class="footer-links">
            <a href="#" class="small-link">公告</a>
            <a href="#" class="small-link">推荐</a>
            <a href="#" class="small-link">文章列表</a>
            <a href="#" class="small-link">产品中心</a>
            <a href="#" class="small-link">批文广告</a>
            <a href="#" class="small-link">留言</a>
          </span>
        </span>
        <span class="footer-divider">|</span>
        <span class="footer-item">用户操作：
          <span class="footer-links">
            <a href="#" class="small-link">用户中心</a>
            <a href="#" class="small-link">注销</a>
          </span>
        </span>
      </div>
      <!-- 版权信息 -->
      <div class="copyright">
        © 2024 挑我啦(www.tiaowola.com)官方网站，保留所有权利！ 备案信息:粤ICP备20032125号-2
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.nav-bar {
  background-color: #3182ce;
  padding: 1rem 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.nav-item {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #2c5282;
  color: #e2e8f0;
}

.router-view-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.router-link-active {
  background-color: #2c5282;
}

/* 更新底部样式 */
.footer {
  background-color: #f7fafc;
  padding: 1rem 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: #4a5568;
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0 1rem;
  margin-bottom: 1rem;
}

.footer-item {
  white-space: nowrap;
  color: #718096;
}

.footer-link {
  color: #4a5568;
  text-decoration: none;
  font-size: 0.75rem;
  margin: 0 2px;
}

.footer-link:hover {
  color: #3182ce;
  text-decoration: underline;
}

.footer-divider {
  color: #cbd5e0;
  margin: 0 0.5rem;
}

/* 版权信息样式 */
.copyright {
  text-align: center;
  color: #718096;
  font-size: 0.875rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
  margin: 0 1rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
  }
  
  .footer-divider {
    display: none;
  }
  
  .footer-item {
    margin: 0.25rem 0;
  }
  
  .copyright {
    padding: 1rem;
  }
}

/* 只调整链接的字体大小 */
.small-link {
  color: #4a5568;
  text-decoration: none;
  font-size: 0.75rem;
  margin: 0 2px;
}

.small-link:hover {
  color: #3182ce;
  text-decoration: underline;
}
</style>
